import { EMPTY_LIST } from '../../constants/common'

import {
  FIELD_VARIABLE_USAGE_LABEL_KEY,
  FIELD_VARIABLE_USAGE_SEPARATOR,
} from './FieldVariable.constants'

function isFieldVariableUsageKnown(usage) {
  return Object.hasOwn(FIELD_VARIABLE_USAGE_LABEL_KEY, usage)
}

export function getFieldVariableDescription({ description, i18n, t }) {
  const key = `FieldVariableDescriptions.${description}Key`

  return i18n.exists(key) ? t(key) : null
}

export function getFieldVariableUsages({ t, usedIn = EMPTY_LIST }) {
  return usedIn
    .filter(isFieldVariableUsageKnown)
    .map(usage => t(FIELD_VARIABLE_USAGE_LABEL_KEY[usage]))
    .join(FIELD_VARIABLE_USAGE_SEPARATOR)
}
